import { useCallback, useEffect, useRef, useState } from "react";
import { useSingleEffect } from "./SingleEffect.hook";

export const useTrackScrollTop = (onScroll?: (scrollTop: number) => void) => {
    const [scrollTop, setScrollTop] = useState(0);
    const ref = useRef<HTMLDivElement>(null);
    const onScrollRef = useRef(onScroll);
    onScrollRef.current = onScroll;
    useSingleEffect(() => {
        let cb: any;
        ref.current?.addEventListener("scroll", cb = () => {
            const value = ref.current?.scrollTop || 0;
            setScrollTop(value);
            onScrollRef.current?.(value);
        });
        return () => {
            ref.current?.removeEventListener("scroll", cb);
        };
    });

    const scrollTo = useCallback((options?: ScrollToOptions) => {
        ref.current?.scrollTo(options);
    }, []);

    return {
        scrollTop,
        ref,
        scrollTo
    };
};